import Box from '@zenbusiness/zui/Box';
import superstyled from '@zenbusiness/zui/styles/superstyled';
import Text from '@zenbusiness/zui/Text';

export const ChoiceFlowRoot = superstyled({
  name: 'ChoiceFlow',
  slot: 'Root',
  tag: Box,
  styles: ({ theme }) => ({
    maxWidth: '100%',
    margin: '0 auto',
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.grey.light,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.border.main}`
  })
});

export const FlowTitle = superstyled({
  name: 'ChoiceFlow',
  slot: 'Title',
  tag: Text,
  styles: ({ theme }) => ({
    marginBottom: theme.spacing(3),
    textAlign: 'center',
    fontWeight: theme.typography.fontWeightBold
  })
});

export const ProgressContainer = superstyled({
  name: 'ChoiceFlow',
  slot: 'ProgressContainer',
  tag: Box,
  styles: ({ theme }) => ({
    marginBottom: theme.spacing(4)
  })
});

export const ProgressText = superstyled({
  name: 'ChoiceFlow',
  slot: 'ProgressText',
  tag: Text,
  styles: ({ theme }) => ({
    textAlign: 'left',
    color: theme.palette.text.secondary
    // fontSize: theme.typography.fontSize.sm
  })
});

export const FlowContent = superstyled({
  name: 'ChoiceFlow',
  slot: 'Content',
  tag: Box,
  styles: () => ({
    width: '100%'
  })
});

export const ErrorMessage = superstyled({
  name: 'ChoiceFlow',
  slot: 'ErrorMessage',
  tag: Text,
  styles: ({ theme }) => ({
    color: theme.palette.error.main,
    textAlign: 'center',
    padding: theme.spacing(3)
  })
});
